import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceListApiService {

  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getAllPriceList(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/price-list/all`, { params: filters }));
  }

  searchPriceList(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/price-list/search`, { params: filters }));
  }

  getAllPriceCampaign() {
    return firstValueFrom(this.http.get(`${this.endpoint}/price-campaign/all`));
  }

  updatePrice(id: string, body: { id: string, price: number }) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/price-list/update-price/${id}`, body));
  }

  updatePriceList(id: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/price-list/update/${id}`, body));
  }

  getAllCampaignGroup() {
    return firstValueFrom(this.http.get(`${this.endpoint}/campaign-group/all`));
  }

  validatePriceList() {
    return firstValueFrom(this.http.patch(`${this.endpoint}/price-list/validate`, {}));
  }

  syncAllProduct() {
    return firstValueFrom(this.http.post(`${this.endpoint}/product/sync-all`, {}));
  }

  createPriceList(sku: string) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/price-list/create/${sku}`, {}));
  }

  getPriceByCampaign(body: { price_campaign_id: string; skus: string[]; }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/price-list/price/campaign`, body));
  }

  getAllProductPlatform(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-platform/all`, body));
  }

}
